import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { MoneyValue } from '~/modules/common/components';

const useStyles = makeStyles(theme => ({
  money: {
    display: 'flex'
  }
}));

const RateReadOnly = ({ value }) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.money}>
        <MoneyValue money={value} />
      </div>
    </>
  );
};

RateReadOnly.propTypes = {
  value: PropTypes.string
};

export default RateReadOnly;
